import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import MembershipClient from "../client/index.js";
import MembershipBrowserPersistence from "../browserPersistence/index.js";
import MembershipAnalytics from "../analytics/index.js";
import { createFakeSuccessfulLogoutResponse, createFakeUnauthorizedResponse } from "./fakeResponses/index.js";

var _client = /*#__PURE__*/new _WeakMap();

var _persistence = /*#__PURE__*/new _WeakMap();

var _analytics = /*#__PURE__*/new _WeakMap();

var _storeSession = /*#__PURE__*/new _WeakMap();

export default class MembershipService {
  constructor() {
    let {
      persistenceOptions,
      clientOptions,
      analyticsOptions,
      client = new MembershipClient(clientOptions),
      persistence = new MembershipBrowserPersistence(persistenceOptions),
      analytics = new MembershipAnalytics(analyticsOptions)
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classPrivateFieldInitSpec(this, _client, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _persistence, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _analytics, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _storeSession, {
      writable: true,
      value: result => {
        _classPrivateFieldGet(this, _persistence).onLogIn(result.data.session);

        return result;
      }
    });

    _classPrivateFieldSet(this, _client, client);

    _classPrivateFieldSet(this, _persistence, persistence);

    _classPrivateFieldSet(this, _analytics, analytics);
  }

  signUp(params) {
    const finalParams = {
      brand_version: _classPrivateFieldGet(this, _persistence).getBrandVersion(),
      ...params
    };
    return _classPrivateFieldGet(this, _client).createMember(finalParams).then(_classPrivateFieldGet(this, _storeSession)).then(result => _classPrivateFieldGet(this, _analytics).reportSignUp(result.data).then(() => result));
  }

  logIn(params) {
    return _classPrivateFieldGet(this, _client).createSession(params).then(_classPrivateFieldGet(this, _storeSession)).then(result => _classPrivateFieldGet(this, _analytics).reportLogIn(result.data).then(() => result));
  }

  getSessionToken() {
    return _classPrivateFieldGet(this, _persistence).getSessionToken();
  }

  getMember() {
    const token = this.getSessionToken();

    if (token) {
      return _classPrivateFieldGet(this, _client).getMember({
        token
      });
    }

    return _Promise.reject(createFakeUnauthorizedResponse());
  }

  updateMember(member) {
    return _classPrivateFieldGet(this, _client).updateMember({
      token: this.getSessionToken(),
      member
    });
  }

  changePassword(member) {
    return _classPrivateFieldGet(this, _client).changePassword({
      token: this.getSessionToken(),
      member
    }).then(_classPrivateFieldGet(this, _storeSession));
  }

  logOut() {
    const token = this.getSessionToken();

    if (token) {
      _classPrivateFieldGet(this, _persistence).deleteSessionToken();

      _classPrivateFieldGet(this, _analytics).reset();

      return _classPrivateFieldGet(this, _client).deleteSession({
        token
      });
    }

    return _Promise.resolve(createFakeSuccessfulLogoutResponse());
  }

  deactivate() {
    return _classPrivateFieldGet(this, _client).deactivate({
      token: this.getSessionToken()
    }).then(result => {
      _classPrivateFieldGet(this, _persistence).deleteSessionToken();

      return result;
    });
  }

  sendResetPasswordEmail(_ref) {
    let {
      email
    } = _ref;
    return _classPrivateFieldGet(this, _client).sendResetPasswordLink({
      email
    });
  }

  resetPassword(params) {
    return _classPrivateFieldGet(this, _client).resetPasswordTokens(params);
  }

  validResetPasswordToken(resetPasswordToken) {
    return _classPrivateFieldGet(this, _client).validResetPasswordToken(resetPasswordToken);
  }

}